import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { RiskIndexCNMVVariantType } from '../../../../../../components/riskIndexCNMV/types/riskIndexCNMVVariantType';
import { TextVariantType } from '../../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [RiskIndexCNMVVariantType.DEFAULT]: {
            rootContainer: {
                display: 'flex',
                flex_direction: 'column',
                width: '100%',
                background_color: FOUNDATIONS.color_neutral_bg_static_100,
                border: `${FOUNDATIONS.border_25} solid ${FOUNDATIONS.color_comp_legal_riskindex_border}`,
            },
            riskLevelBarAndDescriptionContainer: {
                display: 'flex',
                flex_direction: 'row',
                [DeviceBreakpointsType.MOBILE]: {
                    flex_direction: 'column',
                },
            },
            riskLevelBarContainer: {
                padding: FOUNDATIONS.spacing_150,
                flex: '1 0 0',
            },
            descriptionContainerStyled: {
                display: 'flex',
                align_items: 'center',
                align_self: 'stretch',
                padding: FOUNDATIONS.spacing_150,
                flex: '1 0 0',
                border_left: `${FOUNDATIONS.border_25} solid ${FOUNDATIONS.color_comp_legal_riskindex_border}`,
                [DeviceBreakpointsType.MOBILE]: {
                    border_left: 'none',
                    border_top: `${FOUNDATIONS.border_25} solid ${FOUNDATIONS.color_comp_legal_riskindex_border}`,
                },
            },
            description: {
                font_variant: TextVariantType.FONT_PARAGRAPH_500,
                color: FOUNDATIONS.color_comp_legal_riskindex_font,
            },
            icon: {
                width: FOUNDATIONS.size_200,
                height: FOUNDATIONS.size_200,
            },
            alertsContainer: {
                padding: FOUNDATIONS.spacing_150,
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_100,
                border_top: `${FOUNDATIONS.border_25} solid ${FOUNDATIONS.color_comp_legal_riskindex_border}`,
            },
            dlContainer: {
                display: 'flex',
                flex_direction: 'column',
                row_gap: FOUNDATIONS.spacing_100,
            },
            ddContainer: {
                display: 'flex',
                flex_direction: 'row',
                column_gap: FOUNDATIONS.spacing_50,
            },
            liquidityAlertsContainer: {
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_100,
            },
            liquidityAlert: {
                font_variant: TextVariantType.FONT_PARAGRAPH_500,
                color: FOUNDATIONS.color_comp_legal_riskindex_font,
            },
            liquidityAlertDescription: {
                font_variant: TextVariantType.FONT_PARAGRAPH_500,
                color: FOUNDATIONS.color_comp_legal_riskindex_font,
            },
            liquidityListContainer: {
                display: 'flex',
                flex_direction: 'column',
                row_gap: FOUNDATIONS.spacing_100,
                // reset list position
                margin: '0px',
                padding: '0px',
            },
            liquidityAlertContainer: {
                display: 'flex',
                flex_direction: 'row',
                gap: FOUNDATIONS.spacing_50,
            },
            complexityAlertsContainer: {
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_100,
            },
            complexityAlert: {
                font_variant: TextVariantType.FONT_PARAGRAPH_500,
                color: FOUNDATIONS.color_comp_legal_riskindex_font,
            },
            complexityAlertDescription: {
                font_variant: TextVariantType.FONT_PARAGRAPH_500,
                color: FOUNDATIONS.color_comp_legal_riskindex_font,
            },
            complexityListContainer: {
                display: 'flex',
                flex_direction: 'column',
                row_gap: FOUNDATIONS.spacing_100,
                // reset list position
                margin: '0px',
                padding: '0px',
            },
            complexityAlertContainer: {
                display: 'flex',
                flex_direction: 'row',
                gap: FOUNDATIONS.spacing_50,
            },
        },
    };
};
//# sourceMappingURL=default.js.map